import React, {useState} from 'react';
import './Input.css'
import SkynetCopy from "../../Fundamentals/SkynetCopy";
import PhoneLink from "../../PhoneLink";
import {FormControl} from "../FormControl";
import { Link } from "react-router-dom";

export const InputSize = {
    LARGE: 'skynet-lg-input'
}

export const InputType = {
    TEL: 'tel',
    TEXTAREA: 'textarea',
    LINK: 'link',
    EMAIL: 'email',
    NUMBER: 'number',
}

export function ReadOnlyField({ label, value, icon, error, size, allowCopy, type }) {
    const [toggleCopy, setToggleCopy] = useState();
    const iconClass = label ? 'skynet-input-icon':'skynet-input-icon-no-label';

    const className = `form-control skynet-input skynet-input-field p-6 ${size ? size : ''}`

    const attributes = {
        className: className,
        id: value,
    }
    
    if (allowCopy) {
        attributes.onClick = () => setToggleCopy(!toggleCopy);
        attributes.className += " skynet-input-copy";
    }
    
    return (<FormControl controls={{ error }}>
            {label && <label htmlFor={value}>{label}</label>}
            <div {...attributes}>{value}</div>
            {allowCopy &&
                <SkynetCopy label={label ?? value} value={value} classList={`${iconClass}${icon ? " mr-32 skynet-input-divider" :""}`} toggleCopy={toggleCopy}/>}
            {icon && (type === InputType.TEL ?
                <PhoneLink phoneNumber={value} classList={iconClass}/>
                :
                <span className={`vismaicon vismaicon-sm ${iconClass} ${icon}`}/>)}
        </FormControl>
    );
}

export function FormInput({ type, label, value, icon, readOnly, onChange, placeholder, disabled, required = false, loading, onBlur, error, size, link }) {
    const [toggleCopy, setToggleCopy] = useState();
    const iconClass = label ? 'skynet-input-icon':'skynet-input-icon-no-label';
    
    const className = `form-control ${readOnly ? 'skynet-input' : 'rounded-8 skynet-form-input'} ${size ? size : ''}`
    
    const attributes = {
        readOnly: readOnly,
        className: className,
        id: value,
        placeholder,
        disabled,
        onBlur,
        link
    }
    function onClick() {
        setToggleCopy(!toggleCopy);
    }

    return (<FormControl controls={{ required, error }}>
            {label && <label htmlFor={value}>{label}</label>}
            <Input type={type} {...attributes} value={value} onChange={onChange} onClick={readOnly && onClick} placeholder={placeholder}/>
            {loading &&
                <span className={`${iconClass} spinner spinner-xs spinner-default-green mr-4 mt-2`}></span>}
            {readOnly &&
                <SkynetCopy label={label ?? value} value={value} classList={`${iconClass}${icon ? " mr-32 skynet-input-divider" :""}`} toggleCopy={toggleCopy}/>}
            {icon && (type === 'tel' ?
                <PhoneLink phoneNumber={value} classList={iconClass}/>
                :
                <span className={`vismaicon vismaicon-sm ${iconClass} ${icon}`}/>)}
        </FormControl>
    );
}

// Base Input class. Extend and wrap this component in a new component and add your own logic there.
function Input({ type, value, onChange, onClick, ...props}) {

    let inputProps = {
        onClick: (e) => onClick && onClick(e.target.value),
        value: value ?? '',
        disabled: props.disabled,
        readOnly: props.readOnly,
        placeholder: props.placeholder,
        className: props.className ? props.className : "skynet-input",
    };

    const finalProps = Object.assign({}, inputProps, props);

    switch(type) {
        case InputType.TEXTAREA:
            return <textarea {...finalProps} onChange={(e) => onChange(e.target.value)} />
        case InputType.LINK:
            return <p className="p-2"><Link to={props.link} target={"_blank"}>{value}</Link></p>
        default:
            return <input value={value} type={type ? type : "text"} {...finalProps} onChange={(e) => onChange(e.target.value)}/>
    }
 }